
import { Interview } from "@/types/interview";

/**
 * Service responsible for mapping database interview records to the Interview model
 */
export class InterviewMapperService {
  /**
   * Maps a database interview record to the Interview model
   */
  static mapDatabaseInterviewToModel(data: any): Interview {
    return {
      id: data.id,
      context: data.context,
      contextUrl: data.context_url || undefined, // Map context_url field
      contextImageUrl: data.context_image_url || undefined,
      contextImageCaption: data.context_image_caption || undefined,
      question: data.question,
      answer: data.answer,
      intervieweeName: data.interviewee_name,
      title: data.title,
      jobTitle: data.job_title || undefined,
      company: data.company,
      timestamp: data.timestamp,
      photoUrl: data.photo_url || undefined, // Important: use undefined rather than empty string
      photoUrl2: data.photo_url_2 || undefined, // Second interviewee profile picture
      photographerCredit: data.photographer_credit || undefined,
      tags: data.tags || [],
      aiSummary: data.ai_summary || '',
      aiResponse: data.ai_response || '',
      summary_status: this.validateSummaryStatus(data.summary_status),
      summary_error: data.summary_error,
      publication_status: this.validatePublicationStatus(data.publication_status),
      is_in_feeder: data.is_in_feeder || false,
      commentCount: data.comment_count || 0,
      updated_at: data.updated_at,
      articleType: data.article_type || undefined,
      sourceArticles: data.source_articles || undefined,
      isSponsored: data.is_sponsored || false,
      sponsorCompany: data.sponsor_company || undefined
    };
  }

  /**
   * Validate summary status to ensure it matches the expected type
   */
  static validateSummaryStatus(status: string | null): Interview['summary_status'] {
    if (status === 'pending' || status === 'generating' || status === 'completed' || status === 'error') {
      return status;
    }
    return 'pending'; // Default fallback
  }

  /**
   * Validate publication status to ensure it matches the expected type
   */
  static validatePublicationStatus(status: string | null): Interview['publication_status'] {
    if (status === 'pending' || status === 'published' || status === 'rejected') {
      return status;
    }
    return 'pending'; // Default fallback
  }
}
